import React, { Fragment, useEffect } from 'react'
import Avatar from '../../components/Avatar'
import Typography from '../../components/Typography'
import { connect } from 'react-redux'
import { chatSelector } from '../../../../../store/selector'
import IconButton from '../../components/Buttons/IconButton'
import "./rightContent.css"
import { chatAction, messageAction } from '../../../../../store/action'

const Information = ({ ObjKey, value }) => {
      return (
        <div className='d-flex align-items-center justify-content-between information__main'>
          <Typography className='mr-3' variant='secondary' text={ObjKey} noWrapper={true} />
          <Typography variant='dark-blue' text={value} />
        </div>
      )

}


function Index({ selectedAssignedList ,dynamicUpdate, showCustomerInfo,...props}) {
  const customerName = selectedAssignedList && selectedAssignedList.customer && selectedAssignedList.customer.display;
  const hideInfo = ()=>{
    dynamicUpdate({ data: { key: 'showCustomerInfo', value: false } });
  }

  useEffect(()=>{
    console.log("This is a showcusotmerinfo", showCustomerInfo)
  },[showCustomerInfo])

  return (
    <div className='right-content__main'>
      <div className='d-flex align-items-center justify-content-between right-content__top min-w-0' >
        <div className='d-flex align-items-center min-w-0'>
          <Avatar imageUrl="https://picsum.photos/200" size='lg' />
          <Typography text={customerName} className='mx-1' />
        </div>
        <IconButton icon='close' onClick = {hideInfo} />
      </div>
      <Information ObjKey={"Email"} value={"Swayam@gmail.com"} />
      <Information ObjKey={"Number"} value={"+91 293752359"} />
      <Information ObjKey={"City"} value={"Ahmedabad"} />
      <Information ObjKey={"Website"} value={"www.woaig.com"} />
    </div>
  )
}

const stateToProps = state => ({
  selectedAssignedList: chatSelector.getChatDynamic(state, 'selectedAssignedList'),
  showCustomerInfo: chatSelector.getChatDynamic(state, 'showCustomerInfo'),
});

const dispatchToProps = dispatch => ({
  configProcessor: (type, messageData) => {
    dispatch(messageAction.configProcessor(type, messageData));
  },
  dynamicUpdate: (type, messageData) => {
    dispatch(chatAction.dynamicUpdate(type, messageData));
  }
});
export default connect(stateToProps,dispatchToProps)(Index);


// WEBPACK FOOTER //
// src/modules/screens/chatscreen/modules/rightContent/index.js